const WEEKDAYS = ["ne", "po", "út", "st", "čt", "pá", "so"];

export function formatDateFull(dateStr) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.split("-");
  return `${d}.${m}.${y}`;
}

export function formatDateShort(dateStr) {
  // "po 15.3."
  if (!dateStr) return "";
  const dt = new Date(dateStr + "T00:00:00");
  const wd = WEEKDAYS[dt.getDay()];
  return `${wd} ${dt.getDate()}.${dt.getMonth() + 1}.`;
}

export function formatCurrency(value) {
  const n = Number(value || 0);
  return n.toLocaleString("cs-CZ", { maximumFractionDigits: 0 }) + " Kč";
}

export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr + "T00:00:00");
  return Math.round((target - today) / 86400000);
}

export const CZ_MONTHS = [
  "Leden", "Únor", "Březen", "Duben", "Květen", "Červen",
  "Červenec", "Srpen", "Září", "Říjen", "Listopad", "Prosinec",
];

export function mapsUrl(address) {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address || "")}`;
}
